/*jshint esversion: 6 */
document.addEventListener('DOMContentLoaded', function() {
	const buttons = document.querySelectorAll('.btn-festivalyear');

	if (buttons.length > 0 && buttons[0].parentElement) {
		buttons[0].parentElement.classList.add('active');
	}

	buttons.forEach(function(button) {
		button.addEventListener('click', function(e) {
			e.preventDefault();
			if (this.parentElement) {
				this.parentElement.classList.toggle('active');
			}
		});
	});
});
